import type { VerticalBeamPosition } from "entities/configurator/model/layoutMeta";
import { getStaanderPositionName } from "entities/configurator/model/layoutChoiceName";
import { staanderPositions } from "entities/configurator/model/staander";
import { motion, useReducedMotion } from "framer-motion";
import { useId } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { StaanderChoiceHeader } from "features/option-controls/layout-option-controls/StaanderChoiceHeader";
import { WidthSimpleButton } from "features/option-controls/measurements-option-controls/components/WidthSimpleButton";
import { LayoutChoiceGrid } from "./LayoutChoiceGrid";

type StandingLayoutChoicesProps = {
  layouts: OptionTemplate[];
  selectedLayoutCode: string | undefined;
  staanderPosition: VerticalBeamPosition | undefined;
  onChangeLayout: (layout: OptionTemplate) => void;
  onChangeStaander: (position: VerticalBeamPosition | undefined) => void;
};

export const StandingLayoutChoices = ({
  layouts,
  selectedLayoutCode,
  staanderPosition,
  onChangeLayout,
  onChangeStaander,
}: StandingLayoutChoicesProps) => {
  const standingGroupId = useId();
  const hasStaander = staanderPosition !== undefined;
  const shouldReduceMotion = useReducedMotion();
  const handleRemoveStaander = () => onChangeStaander(undefined);

  return (
    <div className="standing-group-choice-container gg-w-full">
      <LayoutChoiceGrid
        layouts={layouts}
        selectedLayoutCode={selectedLayoutCode}
        onChangeLayout={onChangeLayout}
        className="gg-mt-2.5 sm:gg-mt-5"
        variant="standing"
      />
      <StaanderChoiceHeader
        headingId={standingGroupId}
        showRemove={hasStaander}
        onRemove={handleRemoveStaander}
      />
      <motion.div
        layout={shouldReduceMotion ? false : "position"}
        layoutDependency={hasStaander}
        transition={{
          layout: { duration: 0.18, ease: [0.22, 1, 0.36, 1] },
        }}
        role="group"
        aria-labelledby={standingGroupId}
        className="standing-group-choice-grid gg-grid gg-gap-x-2 gg-gap-y-4"
      >
        {staanderPositions.map((position) => (
          <WidthSimpleButton
            key={position}
            onClick={() => onChangeStaander(position)}
            isActive={position === staanderPosition}
            variant="wrapping-sublayout"
          >
            {getStaanderPositionName(position)}
          </WidthSimpleButton>
        ))}
      </motion.div>
    </div>
  );
};
